import styled from "styled-components";
import { ActionsContainer } from "../actions/styles";

export const CountdownEditorContainer = styled.div`
  position: relative;
  margin-top: 20%;
  margin-inline: 10%;

  &:hover {
    ${ActionsContainer} {
      opacity: 1;
    }
  }
`;
